import { render } from "./CardNote.vue?vue&type=template&id=fa7e46ee&scoped=true"
import script from "./CardNote.vue?vue&type=script&lang=js"
export * from "./CardNote.vue?vue&type=script&lang=js"

import "./CardNote.vue?vue&type=style&index=0&id=fa7e46ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7e46ee"]])

export default __exports__